<template>
    <div class="invoice" id="invocie-add">
        <SOSlotBase :bg-grey="false" :loading="isFetching">
            <template v-slot:title-bar>
                <SOTitleBar :type="'back'" :page-title="page.title" @back="back" />
            </template>
            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>
            <template v-slot:empty-state v-if="transaksiTotal === 0">
                <div class="empty-criteria">
                    <div class="empty-state responsive-item" id="so-empty-search-state">
                        <SOIconBase view-box="0 0 244 155" width="244" height="155">
                            <template v-slot:icon>
                                <EmptyIcon244155 />
                            </template>
                        </SOIconBase>
                        <div class="f-16 f-bold">
                            <span v-if="!isEmptyCriteria">Transaksi dengan kriteria tersebut tidak ditemukan</span>
                            <span v-else>Kriteria transaksi belum diatur</span>
                        </div>
                        <div class="f-14 f-c-midgrey">
                            <span v-if="!isEmptyCriteria">Silakan ubah kriteria dengan filter</span>
                            <span v-else>Silakan atur kriteria dengan filter</span>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:content>
                <div class="p-x-20" style="position: relative">
                    <div class="criteria m-d-16">
                        <div class="criteria-list" v-if="!isEmptyCriteria">
                            <CriteriaAddInvoice :criteria="transaksiFilter" />
                        </div>
                        <div class="f-c-blue f-14 f-semi p-t-8 p-d-8" @click="toggleFilter(true)">
                            <p class="m-d-0 center" v-if="!isEmptyCriteria">Ubah kriteria</p>
                            <p class="m-d-0 center" v-else>Atur kriteria</p>
                        </div>
                    </div>
                    <div class="m-d-16">
                        <p class="m-d-0 f-14 f-regular f-c-midgrey">
                            <SOIconBase view-box="0 0 16 17" width="16" height="17">
                                <template v-slot:icon>
                                    <ArrowDown1617 />
                                </template>
                            </SOIconBase>
                            <span>Ditemukan {{ transaksiTotal }} Transaksi</span>
                        </p>
                    </div>
                    <div class="transaksi-item f-16 f-c-black f-regular">
                        <div class="check-all" @click="onToggleCheckAll">
                            <p class="m-d-0 d-flex">
                                <SOCheckBox :is-checked="isCheckAll" />
                                <span class="m-l-8">Pilih semua</span>
                            </p>
                        </div>
                        <div class="list-items">
                            <CardTransaksi type-card="none" :data-list="transaksiList" :load-data="loadTransaksi" />
                            <SOLoadMoreLoading :id="'load-more-pesan'" :loading="isLoadMore" />
                        </div>
                    </div>
                    <div class="d-grid-12 btn-action">
                        <div class="grid-cspan-5 f-regular transaksi-terpilih">
                            <p class="m-d-0 f-12 f-c-midgrey">Terpilih total</p>
                            <p class="m-d-0 f-14 f-c-black">{{ getTotalTransaksi }} Transaksi</p>
                        </div>
                        <div class="grid-cspan-6">
                            <SOButton
                                :primary="true"
                                :full="true"
                                :text="'Pilih Transaksi'"
                                :disable="!allowPilih"
                                :id="`pilih-transaksi`"
                                @action="onPilih"
                            />
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:filter>
                <div>
                    <FilterInvoiceAdd :load-transaksi="doFilter"></FilterInvoiceAdd>
                </div>
            </template>
            <template v-slot:modal>
            <ConfirmLeave
                title="Batal Membuat Invoice"
                body="Yakin ingin membatalkan pembuatan data invoice baru?"
                button-text="Ya, Batal"
                ref="confirmModal"
            />
        </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import resulter from "@/store/utils/resulter";
import { moduleName } from "../store/state";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOCheckBox from "@/so-components/global/ui/SOCheckBox";
import SOButton from "@/so-components/global/ui/SOButton";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";

import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import EmptyIcon244155 from "@/so-components/global/icons/iconPacks/EmptyIcon244155.vue";
import ArrowDown1617 from "@/so-components/global/icons/iconPacks/ArrowDown1617.vue";

import FilterInvoiceAdd from "../components/FilterInvoiceAdd.vue";
import CriteriaAddInvoice from "../components/CriteriaAddInvoice.vue";
import CardTransaksi from "../components/CardTransaksi.vue";
import ConfirmLeave from "@/so-components/global/modal/SOModalConfirm.vue";
export default {
    name: "InvoiceAdd",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOLoadingPage,
        SOLoadMoreLoading,
        SOCheckBox,
        SOButton,
        SOIconBase,
        EmptyIcon244155,
        ArrowDown1617,
        FilterInvoiceAdd,
        CriteriaAddInvoice,
        CardTransaksi,
        ConfirmLeave,
    },
    data() {
        return {
            page: {
                title: "Pilih Transaksi",
                loading: false,
                from: null,
            },
            dataCheckAll: [],
            dataOutlet: [],
            transaksiFilter: {},
            invoiceFilter: {},
        };
    },
    beforeRouteEnter(to, from, next) {
        next(async (vm) => {
            if (from.name === "invoicePenjadwalan.riwayat") {
                if (Object.keys(vm.$store.state.outletModule.outlet).length === 0) {
                    await vm.$store.dispatch("outletModule/fetchOutletAll")
                }
                vm.doFilter();
                vm.updateFilter();
            }
            vm.setInvoiceFilter();
            vm.page.from = from
            if (from.name === "invoice.list") {
                vm.init();
            }

            if (from.name === "invoice.create") {
                vm.updateFilter();
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        if (to.name === "invoice.list") {
            this.$refs.confirmModal.open().then(isAccept => {
                if (isAccept) {
                    this.$store.commit("filterGlobalModule/setFilterItem", this.invoiceFilter);
                    next();
                }
                else next(false);
            })
        }
        else {
            next();
        }
    },
    mounted() {},
    watch: {
        isFilter: function (nF, oF) {
            if (nF !== oF) {
                if (!nF) {
                    this.updateFilter();
                }
            }
        },
        response: function (nRes, oRes) {
            if (nRes !== oRes) {
                if (nRes.success) {
                    if (nRes.success === false) {
                        this.$toast.error(nRes.err);
                    }

                    this.setLoading(false);
                }
            }
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            isFilter: "isFilter",
            isLoadMore: "isLoadMore",
            response: "response",
            transaksiList: "transaksiList",
            transaksiTotal: "transaksiTotal",
            grandTotalCheck: "grandTotalCheck",
            isCheckAll: "isCheckAll",
            selectedTransaksi: "selectedTransaksi",
            unSelectedTransaksi: "unSelectedTransaksi",
            checkAllItem: "checkAllItem",
        }),
        ...mapGetters("filterGlobalModule", {
            filterItem: "getFilterItem",
        }),
        getTotalTransaksi() {
            if (this.isCheckAll) {
                return this.transaksiTotal - this.unSelectedTransaksi.length;
            } else {
                return this.selectedTransaksi.length;
            }
        },
        allowPilih() {
            return this.selectedTransaksi.length > 0;
        },
        isFetching() {
            return this.page.loading;
        },
        isEmptyCriteria() {
            let filters = this.transaksiFilter;
            if (!filters.filter_by) {
                delete filters.filter_by;
            }
            return Object.keys(filters).length === 0;
        },
    },
    methods: {
        ...mapActions({
            getListTransaksi: `${moduleName}/getListTransaksi`,
            getFilterItem: `${moduleName}/getFilterItem`,
            setGrandTotal: `${moduleName}/setGrandTotal`,
            setFilter: `${moduleName}/setFilter`,
            setCheckAll: `${moduleName}/setCheckAll`,
            setSelectedTransaksi: `${moduleName}/setSelectedTransaksi`,
            setUnselectedTransaksi: `${moduleName}/setUnselectedTransaksi`,
            resetList: `${moduleName}/resetList`,
            resetPage: `${moduleName}/resetPage`,
        }),
        async init() {
            await this.resetFilter();
            await this.resetData();
            await this.setCheckAll(false);
            await this.updateFilter();
            console.log(this.page.from.name);
            this.toggleFilter(true);
        },
        setLoading(val) {
            this.page.loading = val;
        },
        updateFilter() {
            this.getFilterItem().then((filter) => {
                this.transaksiFilter = filter;
            });
        },
        setInvoiceFilter() {
            this.invoiceFilter = this.filterItem;
        },
        async loadTransaksi() {
            await this.getListTransaksi();
        },
        async doFilter() {
            await this.setLoading(true);
            await this.resetData();
            await this.loadTransaksi();
        },
        back() {
            this.$router.go(-1);
        },
        async onToggleCheckAll() {
            if (this.transaksiTotal === 0) {
                this.$toast.warning("Mohon atur kriteria terlebih dahulu!");
                return;
            }
            await this.setCheckAll(!this.isCheckAll);

            if (this.isCheckAll) {
                let itemSelected = [];

                this.transaksiList.forEach((data) => {
                    itemSelected.push(data.idtransaksi);
                });
                await this.setUnselectedTransaksi([]);
                await this.setSelectedTransaksi(itemSelected);
                this.setGrandTotal(this.grandTotalCheck)
            } else {
                let itemUnselected = this.unSelectedTransaksi.concat(this.selectedTransaksi);
                await this.setSelectedTransaksi([]);
                await this.setUnselectedTransaksi(itemUnselected);
                this.setGrandTotal(0)
            }
        },
        toggleFilter(val) {
            this.setFilter(val);
        },
        isSetRequired() {
            let outlet = this.transaksiFilter?.idoutlet_array.length | 0;

            return outlet ? true : false;
        },
        onPilih() {
            if (!this.isSetRequired()) {
                this.$toast.warning("Mohon pilih Outlet terlebih dahulu!");
                return;
            }
            this.$router.push({ name: "invoice.create" });

            // Jika dibutuhkan konfirmasi ketika buat invoice
            /**
             * this.$router.push({ name: "invoice.add.confirm" });
             */
        },
        resetData() {
            this.resetPage({ target: "transaksi" });
            this.resetList({ target: "transaksi" });
            this.setUnselectedTransaksi([]);
        },
        async resetFilter() {
            await this.$store.commit("filterGlobalModule/resetFilterItem");
            let temp = this.filterItem;

            temp.periode = {
                filterBy: "bulan",
                month: this.$moment().format("YYYY-MM"),
            };

            await this.$store.commit("filterGlobalModule/setFilterItem", temp);
        },
    },
};
</script>
<style scoped src="../static/style.css"></style>
